function customSidebarStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, vertical_breakpoints, borders } = theme;
    const { transparentInfo, deviceLayout, miniNavbar } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    const { values: { vxs, vsm, vmd, vlg, vxl, vxxl, vx3l } } = vertical_breakpoints;

    var max_width = deviceLayout == 'mobile' ? 'unset' : pxToRem(860);

    return {
        [breakpoints.up('xxs')]: {
            height: miniNavbar ? 'auto' : 'inherit',
        },
        [breakpoints.up('xl')]: {
            [`@media (min-height:${vxs}px)`]: {
                height: '40svh',
            },
            [`@media (min-height:${vsm}px)`]: {
                height: '51svh',
            },
            [`@media (min-height:${vmd}px)`]: {
                height: '58svh',
            },
            [`@media (min-height:${vlg}px)`]: {
                height: '65svh',
            },
            [`@media (min-height:${vxl}px)`]: {
                height: '68svh',
            },
            [`@media (min-height:${vxxl}px)`]: {
                height: '66svh',
            },
        },

        maxWidth: max_width,
        "& > *": {
            transition: transitions.create("all", {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.standard,
            }),
        },

        "& .MuiToolbar-root": {
            [breakpoints.up("xxs")]: {
                minHeight: "auto",
            },
        },

        transition: `width 300ms ease-in-out, height 300ms ease-in-out`,
    }
}

function sidebarTabStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { transparentInfo, deviceLayout } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, rgb, pxToRem } = functions;
    const { borderRadius } = borders;

    return {
        boxShadow: navbarBoxShadow,
        backdropFilter: `saturate(200%) blur(${pxToRem(4)})`,
        backgroundColor: rgba(white.main, 0.8),
        color: white.main,
        borderRadius: borderRadius.xl,

        paddingTop: pxToRem(8),
        paddingBottom: pxToRem(8),
        paddingRight: pxToRem(8),
        paddingLeft: pxToRem(8),

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        pointerEvents: 'auto',

        "& > *": {
            transition: transitions.create("all", {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.standard,
            }),
        },
    };
}

function sidebarToggleStyle(theme) {
    const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;

    const { dark, white, text, transparent } = palette;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    return {
        boxShadow: "none",
        backdropFilter: true ? "none" : `saturate(200%) blur(${pxToRem(4)})`,
        backgroundColor: rgba(white.main, 0.8),
        borderRadius: borderRadius.xl,
        minWidth: pxToRem(50),
        height: pxToRem(200),
        padding: pxToRem(8),
        cursor: 'pointer',
        pointerEvents: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        "&:hover": {
            backgroundColor: '#CCCCCC !important',
        },

        transition: "background-color 300ms ease, color 300ms ease",
    };
}

function sidebarHeadersStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { transparentInfo } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular, fontWeightBold } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    return {
        "& .userWelcome": {
            "& > *": {
                [breakpoints.up('xxs')]: {
                    fontSize: typography.h5,
                },
                [breakpoints.up('lg')]: {
                    fontSize: typography.h4,
                },
                [breakpoints.up('xl')]: {
                    fontSize: typography.h3,
                },
                [breakpoints.up('xxl')]: {
                    fontSize: typography.h2,
                },

                textTransform: 'capitalize',
                fontWeight: fontWeightBold,
                transition: 'font-size 300ms ease-in-out'
            }
        },

        "& .subheading": {
            "& > *": {
                [breakpoints.up('xxs')]: {
                    fontSize: typography.h6,
                },
                [breakpoints.up('xl')]: {
                    fontSize: typography.h5,
                },

                fontWeight: fontWeightRegular,
                transition: 'font-size 300ms ease-in-out'
            }
        }
    };
}

function exploreContentStyle(theme, ownerState) {
    const { palette, typography, boxShadows, functions, transitions, breakpoints, vertical_breakpoints, borders } = theme;
    const { transparentInfo, miniNavbar } = ownerState;

    const { dark, white, text, transparent, gradients } = palette;
    const { size, fontWeightMedium, fontWeightRegular, fontWeightBold } = typography;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    const { values: { vxs, vsm, vmd, vlg, vxl, vxxl, vx3l } } = vertical_breakpoints;

    return {
        [breakpoints.up('xxs')]: {
            display: miniNavbar ? 'none' : 'inherit',
            height: '100%',
        }
    }
}

export {
    customSidebarStyle,
    sidebarTabStyle,
    sidebarToggleStyle,
    sidebarHeadersStyle,
    exploreContentStyle
}